import { InteractionType, type RedirectRequest } from "@azure/msal-browser";
import { MsalAuthenticationTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import React, { useMemo } from "react";
import { isPrPreview, loginRequest, msalInstance } from "./";
const authDisabled = import.meta.env.VITE_DISABLE_AUTH === "true";
interface AuthenticationCompontentProps {
  children: React.ReactNode;
}

export const AuthenticationCompontent: React.FC<AuthenticationCompontentProps> = ({ children }) => {
  // For PR preview environments, encode the origin in the MSAL state parameter.
  // The static redirect page at the base SWA reads this to know where to redirect back.
  const authRequest: RedirectRequest = useMemo(() => {
    if (isPrPreview()) {
      return {
        ...loginRequest,
        state: `pr_origin:${encodeURIComponent(window.location.origin)}`,
      };
    }
    return loginRequest;
  }, []);

  if (authDisabled) return <>{children}</>;
  return (
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest}>
        {children}
      </MsalAuthenticationTemplate>
      <UnauthenticatedTemplate />
    </MsalProvider>
  );
};

export default AuthenticationCompontent;
